export default {
  setYearAndMonth({commit},yearMonth) {
    commit('SET_YEAR_AND_MONTH',yearMonth)
  },
  setYearAndMonthToShared({commit},yearMonth) {
    commit('SET_YEAR_AND_MONTH_TS',yearMonth)
  },
  setImgName({commit},imgName) {
    commit('SET_IMG_NAME',imgName)
  },
  setBackupInfo({commit},backupInfo) {
    commit('SET_BACKUP_INFO',backupInfo)
  },
  setIncomeCostData({commit},incomeCostData) {
    commit('SET_INCOME_COST_DATA',incomeCostData)
  },
  setIncomeDetailData({commit},incomeDetailData) {
    commit('SET_INCOME_DETAIL_DATA',incomeDetailData)
  },
  setCostDetailData({commit},costDetailData) {
    commit('SET_COST_DETAIL_DATA',costDetailData)
  }
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js